import {
    LayoutDashboard,
    GitBranch,
    Wallet,
    LockOpen,
    Users,
    PinIcon,
    Vault,
    Contact
} from 'lucide-react';

// import pages
import Login from '../pages/Login';
import Dashboard from '../pages/Dashboard';
import UserList from '../pages/UserList';
import PinList from '../pages/PinList';
import PinLogList from '../pages/PinLogList';
import BinaryTree from '../pages/BinaryTree';
import WithdrawList from '../pages/WithdrawList';
import BonusHistory from '../pages/BonusHistory';
import ChangePassword from '../pages/ChangePassword';
import NotFound from '../pages/NotFound';
import ContactList from '../pages/ContactList';

const routers = [
    /* AUTH ROUTE */
    {
        path: "/login",
        name: "Login",
        component: Login,
        isSideMenu: false,
        isSideLabel: false,
        icon: null,
        type: 'auth'
    },
    /* PUBLIC ROUTE */
    {
        path: "*",
        name: "Not Found",
        component: NotFound,
        isSideMenu: false,
        isSideLabel: false,
        icon: null,
        type: 'public'
    },
    /* PRIVATE ROUTE */
    {
        path: "/dashboard",
        name: "Dashboard",
        component: Dashboard,
        isSideMenu: true,
        isSideLabel: true,
        icon: LayoutDashboard,
        type: 'private'
    },
    {
        path: "/user-list",
        name: "User List",
        component: UserList,
        isSideMenu: true,
        isSideLabel: true,
        icon: Users,
        type: 'private'
    },
    {
        path: "/pin-list",
        name: "Pin List",
        component: PinList,
        isSideMenu: true,
        isSideLabel: true,
        icon: PinIcon,
        type: 'private'
    },
    {
        path: "/pin-log-list/:pinId",
        name: "Pin Log List",
        component: PinLogList,
        isSideMenu: true,
        isSideLabel: false,
        icon: null,
        type: 'private'
    },
    {
        path: "/binary-tree/:userId",
        name: "Binary Tree",
        component: BinaryTree,
        isSideMenu: true,
        isSideLabel: false,
        icon: GitBranch,
        type: 'private'
    },
    {
        path: "/bonus-history",
        name: "Bonus History",
        component: BonusHistory,
        isSideMenu: true,
        isSideLabel: true,
        icon: Vault,
        type: 'private'
    },
    {
        path: "/withdraw",
        name: "Withdraw List",
        component: WithdrawList,
        isSideMenu: true,
        isSideLabel: true,
        icon: Wallet,
        type: 'private'
    },
    {
        path: "/contact",
        name: "Conatct List",
        component: ContactList,
        isSideMenu: true,
        isSideLabel: true,
        icon: Contact,
        type: 'private'
    },
    {
        path: "/change-password",
        name: "Change Password",
        component: ChangePassword,
        isSideMenu: true,
        isSideLabel: true,
        icon: LockOpen,
        type: 'private'
    },
];

export default routers;